import React,{} from "react";
import { NavLink } from "react-router-dom";
import { HashLink as Link } from "react-router-hash-link";

import Logo from '../../atoms/logo/logo';

import "./header.scss";


const Header = () => {

	const toggleMenu = () => {
		const nav = document.getElementById("js-navbar");
		nav.classList.toggle("header__navbar--open");
	}

	const closeMenu = () => {
		document.getElementById("js-hamburger").click();
        document.body.scroll({top: 0, left: 0, behavior: 'smooth' }) 
	}

    
    const scrollWithOffset = (el) => {
        el.scrollIntoView({behavior: "smooth", block: "start"});
	};
      

	return (


		<header>
			
			<div className="header" id="js-main-menu">

				<div className="fullwidth-content header__content">

					<div className="header__nav-toggle">

						<input
							onChange={toggleMenu}
							id="js-hamburger"
							type="checkbox"
						/>

						<span></span>
						<span></span>
						<span></span>

					</div>

					<div className="header__logo">

						<Logo />

					</div>

					<div className="header__navbar" id="js-navbar">

 
						<ul className="header__nav-list">

							<li className="header__nav-item header__nav-item--dropdown">

								<NavLink
									className="header__nav-link"
									activeClassName="header__nav-link--active"
									onClick={closeMenu}
									to="/home"
									data-intent="navigational"
									data-scope="header"
									data-id="link_content"
									data-text="home link click"
								>
									Home
								</NavLink>
                    

								<ul className="header__dropdown">

									{/* <li className="header__dropdown-item">
										<Link
											className="header__dropdown-link"
                                            scroll={scrollWithOffset}
											to="#highlights"
											data-intent="navigational"
											data-scope="header"
											data-id="link_content"
											data-text="home | highlights link click"
										>
											Highlights
										</Link>
									</li> */}

									{/* <li className="header__dropdown-item">
										<Link
											className="header__dropdown-link"
                                            scroll={scrollWithOffset}
											to="/#impact"
											data-intent="navigational"
											data-scope="header"
											data-id="link_content"
											data-text="home | impact link click"
										>
											Impact
										</Link>
									</li> */}

									{/* <li className="header__dropdown-item">
										<Link
											className="header__dropdown-link"
                                            scroll={scrollWithOffset}
											to="/#publications"
											data-intent="navigational"
											data-scope="header"
											data-id="link_content"
											data-text="home | publications link click"
										>
											Publications
										</Link>
									</li> */}

								</ul>

							</li>

							<li className="header__nav-item header__nav-item--dropdown">

								<NavLink
									className="header__nav-link"
									activeClassName="header__nav-link--active"
									onClick={closeMenu}
									to="/about"
									data-intent="navigational"
									data-scope="header"
									data-id="link_content"
									data-text="about link click"
								>
									About Us
								</NavLink>

								<ul className="header__dropdown">

									<li className="header__dropdown-item">
										<Link
											className="header__dropdown-link"
                                            scroll={scrollWithOffset}
											to="/about#our-vision"
											data-intent="navigational"
											data-scope="header"
											data-id="link_content"
											data-text="about | our vision link click"
										>
											Our Vision
										</Link>
									</li>

									<li className="header__dropdown-item">
										<Link
											className="header__dropdown-link"
                                            scroll={scrollWithOffset}
											to="/about#our-history"
											data-intent="navigational"
											data-scope="header"
											data-id="link_content"
											data-text="about | our history link click"
										>
											Our History
										</Link>
									</li>

									{/* <li className="header__dropdown-item">
										<Link
											className="header__dropdown-link"
                                            scroll={scrollWithOffset}
											to="/about#milestones"
											data-intent="navigational"
											data-scope="header"
											data-id="link_content"
											data-text="about | milestones link click"
										>
											Milestones
										</Link>
									</li> */}

									<li className="header__dropdown-item">
										<Link
											className="header__dropdown-link"
                                            scroll={scrollWithOffset}
											to="/about#our-team"
											data-intent="navigational"
											data-scope="header"
											data-id="link_content"
											data-text="about | our team link click"
										>
											Our Team
										</Link>
									</li>

									<li className="header__dropdown-item">
										<Link
											className="header__dropdown-link"
                                            scroll={scrollWithOffset}
											to="/about#our-board"
											data-intent="navigational"
											data-scope="header"
											data-id="link_content"
											data-text="about | our board link click"
										>
											Our board
										</Link>
									</li>

									<li className="header__dropdown-item">
										<Link
											className="header__dropdown-link"
                                            scroll={scrollWithOffset}
											to="/about#frequently-asked-questions"
											data-intent="navigational"
											data-scope="header"
											data-id="link_content"
											data-text="about | faqs link click"
										>
											FAQs
										</Link>
									</li>

								</ul>

							</li>

							<li className="header__nav-item header__nav-item--dropdown">

								<NavLink
									className="header__nav-link"
									activeClassName="header__nav-link--active"
									onClick={closeMenu}
									to="/programmes"
									data-intent="navigational"
									data-scope="header"
									data-id="link_content"
									data-text="our programmes link click"
								>
									Our Programmes
								</NavLink>

								<ul className="header__dropdown">

									<li className="header__dropdown-item">
										<Link
											className="header__dropdown-link"
                                            scroll={scrollWithOffset}
											to="/programmes#our-partners"
											data-intent="navigational"
											data-scope="header"
											data-id="link_content"
											data-text="our programmes | our partners link click"
										>
											Our Partners
										</Link>
									</li>

									<li className="header__dropdown-item">
										<Link
											className="header__dropdown-link"
                                            scroll={scrollWithOffset}
											to="/programmes#reports"
											data-intent="navigational"
											data-scope="header"
											data-id="link_content"
											data-text="our programmes | reports link click"
										>
											Reports
										</Link>
									</li>

								</ul>

							</li>

							<li className="header__nav-item header__nav-item--dropdown">

								<NavLink
									className="header__nav-link"
									activeClassName="header__nav-link--active"
									onClick={closeMenu}
									to="/media-and-news"
									data-intent="navigational"
									data-scope="header"
									data-id="link_content"
									data-text="media & news link click"
								>
									Media & News
								</NavLink>

								<ul className="header__dropdown">

									<li className="header__dropdown-item">
										<Link
											className="header__dropdown-link"
                                            scroll={scrollWithOffset}
											to="/media-and-news#video-gallery"
											data-intent="navigational"
											data-scope="header"
											data-id="link_content"
											data-text="media & news | videos link click"
										>
											Videos
										</Link>
									</li>

									<li className="header__dropdown-item">
										<Link
											className="header__dropdown-link"
                                            scroll={scrollWithOffset}
											to="/media-and-news#photo-gallery"
											data-intent="navigational"
											data-scope="header"
											data-id="link_content"
											data-text="media & news | photo gallery link click"
										>
											Photo Gallery
										</Link>
									</li>

									{/* <li className="header__dropdown-item">
										<Link
											className="header__dropdown-link"
                                            scroll={scrollWithOffset}
											to="/media-and-news#tutuwa-partners"
											data-intent="navigational"
											data-scope="header"
											data-id="link_content"
											data-text="media & news | tutuwa & partners link click"
										>
											Tutuwa & Partners
										</Link>
									</li> */}

								</ul>

							</li>

							<li className="header__nav-item">
								<NavLink
									to="/contact"
									onClick={closeMenu}
									className="header__nav-link"
									data-intent="navigational"
									data-scope="header"
									data-id="link_content"
									data-text="contact us link click"
								>
									Contact Us
								</NavLink>
							</li>

							
						</ul> 

					</div>

				</div>

			</div>
			
		</header>
		
	);

};

export default Header;
